import type { StateCreator } from "zustand";
import { create } from "zustand";

type SyncCountProgressData = {
  events?: number;
  emails?: number;
  message?: string;
};

type ZGmailProcessingCardState = {
  isProcessing: Record<string, boolean>;
  setIsProcessing: (id: string, isProcessing: boolean) => void;
  syncProgress: Record<string, SyncCountProgressData>;
  setSyncProgress: (id: string, syncProgress: SyncCountProgressData) => void;
};

const gmailProcessingCardSlice: StateCreator<ZGmailProcessingCardState> = (
  set,
  get,
) => ({
  isProcessing: {},
  setIsProcessing: (id: string = "default", isProcessing: boolean = false) =>
    set({ isProcessing: { ...get().isProcessing, [id]: isProcessing } }),
  syncProgress: {},
  setSyncProgress: (id: string, syncProgress: SyncCountProgressData) =>
    set({ syncProgress: { ...get().syncProgress, [id]: syncProgress } }),
});

export const useGmailProcessingCardStore = create<ZGmailProcessingCardState>()(
  (...args) => ({
    ...gmailProcessingCardSlice(...args),
  }),
);
